import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { AUTH_PREFIX_PATH, UNAUTHENTICATED_ENTRY, REDIRECT_URL_KEY } from 'configs/AppConfig';

const ProtectedRoute = () => {
	const token = localStorage.getItem('token');
	const userId = localStorage.getItem('user_id');

	const location = useLocation();

	// if (!token ) {
	// 	return <Navigate to={`${AUTH_PREFIX_PATH}${UNAUTHENTICATED_ENTRY}?${REDIRECT_URL_KEY}=${location.pathname}`} replace />;
	// }
	if (!userId || !token) {
		return <Navigate to={`${AUTH_PREFIX_PATH}${UNAUTHENTICATED_ENTRY}`} replace />;
	}

	return <Outlet />;
};

export default ProtectedRoute;
